import { Button } from "../../../_helpers/components/Button";
import { DefaultDropdown } from "../../../_helpers/components/Forms/Dropdown";

export const InterventionsCreationModal = (props) => {
    let {
        newTicket,
        handleSubmit,
        setVisible,
        handleChange,
        categories,
        priorities,
        teams,
        usersCanEnroll,
        loading,
    } = props;

    const groupedCategories = Object.values(
        (categories ?? []).reduce((acc, c) => {
          const key = c.family ?? "";
          if (!acc[key]) acc[key] = { group: key, content: [] };
          acc[key].content.push({ value: c.id, label: c.label });
          return acc;
        }, {})
      );

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
            <div className="bg-white lg:rounded-2xl shadow-lg w-full h-full lg:max-w-3xl lg:h-auto p-6 h-max-content overflow-y-auto">
                <h2 className="text-xl font-semibold mb-4">Demander une intervention</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <DefaultDropdown
                        name="Catégorie"
                        required={true}
                        value={newTicket.category_id || (categories.length > 0 ? categories[0].id : "")}
                        // options={categories.map(c => ({ label: c.family + " > " + c.label, value: c.id }))}
                        options={groupedCategories}
                        onChange={(e) => handleChange(e, "category_id")}
                    />
                    <div>
                        
                        <label className="text-left block uppercase tracking-wide text-app-primary text-xs font-bold mb-2">Objet<span className="text-red-600"> *</span></label>
                        <input
                            placeholder="Changement d'une ampoule"
                            type="text"
                            name="title"
                            value={newTicket.title}
                            onChange={(e) => handleChange(e, "title")}
                            className="w-full bg-gray-200 border rounded px-3 py-2"
                        />
                    </div>
                    <div>
                        <label className="text-left block uppercase tracking-wide text-app-primary text-xs font-bold mb-2">Description<span className="text-red-600"> *</span></label>
                        <textarea
                            placeholder="Dans la salle F3"
                            name="description"
                            value={newTicket.description}
                            onChange={(e) => handleChange(e, "description")}
                            className="w-full bg-gray-200 border rounded px-3 py-2"
                            rows="3"
                        ></textarea>
                    </div>
                    <DefaultDropdown
                        name="Priorité"
                        options={[...Object.keys(priorities).map(p => ({ label: priorities[p].label, value: p }))]}
                        required={true}
                        value={newTicket.priority}
                        onChange={(e) => handleChange(e, "priority")}
                    />
                    <DefaultDropdown
                        name="Service"
                        options={teams.map((aTeam) => ({
                            label: aTeam.name,
                            value: aTeam.id,
                        }))}
                        required={true}
                        value={newTicket.team_id}
                        onChange={(e) => handleChange(e, "team_id")}
                    />

                    {usersCanEnroll !== undefined &&
                        <DefaultDropdown
                            key={"performer"}
                            name={"Assignée à"}
                            options={[{ label: "", value: null }, ...usersCanEnroll.map(u => ({ label: (u.last_name ?? "") + " " + (u.first_name ?? ""), value: u.id }))]}
                            value={newTicket.performer_id}
                            onChange={(e) => handleChange(e, "performer_id")}
                        />
                    }

                    <label className="text-left block uppercase tracking-wide text-app-primary text-xs font-bold mb-2">Échéance <span className="text-xs normal-case">(optionnelle)</span></label>
                    <input
                        type="date"
                        className="w-full bg-gray-200 border rounded px-3 py-2"
                        value={newTicket.due_date}
                        onChange={(e) => handleChange(e, "due_date")}
                    />
                    <div className="flex justify-end gap-2 pt-4">
                        <Button name="Annuler" type="empty" action={() => setVisible(false)} />
                        <Button name="Créer" action={handleSubmit} loading={loading} />
                    </div>
                </form>
            </div>
        </div>
    );

}